// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render rebrand banner 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root WithStyles(ForwardRef(Container))-root-1 MuiContainer-maxWidthLg"
      >
        <a
          data-turbolinks="false"
          href="/"
        >
          <img
            alt="Dr. Bill Logo"
            class="img-root-2"
            src="test-file-stub"
          />
        </a>
        <div
          class="WithStyles(ForwardRef(Typography))-root-3"
          variant="h2"
        >
          Welcome to Dr.Bill!
        </div>
        <p
          class="MuiTypography-root WithStyles(ForwardRef(Typography))-root-4 MuiTypography-body2"
        >
          We're excited to give you back some valuable free time—and help ensure you are paid accurately for the work that you do.
        </p>
        <img
          alt="dashboard, new patient, new claim tabs"
          class="img-root-5"
          src="test-file-stub"
        />
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root WithStyles(ForwardRef(Container))-root-1 MuiContainer-maxWidthLg"
    >
      <a
        data-turbolinks="false"
        href="/"
      >
        <img
          alt="Dr. Bill Logo"
          class="img-root-2"
          src="test-file-stub"
        />
      </a>
      <div
        class="WithStyles(ForwardRef(Typography))-root-3"
        variant="h2"
      >
        Welcome to Dr.Bill!
      </div>
      <p
        class="MuiTypography-root WithStyles(ForwardRef(Typography))-root-4 MuiTypography-body2"
      >
        We're excited to give you back some valuable free time—and help ensure you are paid accurately for the work that you do.
      </p>
      <img
        alt="dashboard, new patient, new claim tabs"
        class="img-root-5"
        src="test-file-stub"
      />
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
